module.exports = __webpack_public_path__ + "static/img/sph.9d8c516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sph.png
// module id = G5IA
// module chunks = 2